import { createContext, useContext } from 'react';

const FranchiseFlowAuthContext = createContext(null);

export function FranchiseFlowAuthProvider({ value, children }) {
  return (
    <FranchiseFlowAuthContext.Provider value={value}>{children}</FranchiseFlowAuthContext.Provider>
  );
}

/** @returns {{ onLogout?: () => Promise<void>, logoutBusy?: boolean } | null} */
export function useFranchiseFlowAuthActions() {
  return useContext(FranchiseFlowAuthContext);
}
